const Mock = require('mockjs');
export default [
    // 站点信息
    {
        url: '/api/site',
        type: 'get',
        response: () => {
            return {
                code: 20000,
                data: {
                    avatar: 'https://s2.ax1x.com/2020/01/17/1SCadg.png',
                    slogan: 'The way up is not crowded, and most chose ease.',
                    name: '茶话网',
                    domain: 'https://www.teaclub.top',
                    notice: '本博客的Demo数据由Mockjs生成',
                    desc: '一个简单的记录网站'
                }
            }
        }
    },
    // 站点社交信息
    {
        url: '/api/social',
        type: 'get',
        response: () => {
            return {
                code: 20000,
                data: [
                    {
                        id: 1,
                        title: 'QQ',
                        icon: 'iconqq',
                        color: '#1AB6FF ',
                        href: 'http://www.teaclub.top'
                    }
                ]
            }
        }
    }
]